export enum TipoAllegato {
  Allegato = 0,
  Annesso = 1,
}

export interface DocumentoAllegato {
  streamId: string;
  documentoId: number;
  length: number;
  fileName: string;
  descrizione?: string;
  tipoAllegato?: TipoAllegato;
  ocrTesto: string;
  riproduzione: RiproduzioneJson;
  hasPassword: boolean;
  isPrimario: boolean;
  fromSharedFolder?: boolean;
  isP7m?: boolean;
  extractedFileName?: string | null;
  extractedIsPdf?: boolean;
}
export interface RiproduzioneJson {
  originalStreamId: string;
  allPages: boolean;
  pageRange?: Intervallo[] | null;
}

export interface Intervallo {
  from: number;
  to: number;
}

export interface AllegatiCondivisiRequest {
  currentFileName: string,
  newFileName: string,
}

export interface AllegatiCondivisiDetails {
  fileName: string,
  lastModified: Date,
  size: number,
  newName?: string
}
